export default __webpack_public_path__ + "locales/pl/InviteDialog.json?hash=e518a39ecc9da744804b75453e7ec525";